import { TOOLS_IDS } from './constants';
import {
  getAnnotationsInGroup,
  TEMPLATE_CARD_BACKGROUND_KEY,
} from './annotationGroupUtils';

export const TEXT_TEMPLATE_CARD_PADDING_X = 14;
export const TEXT_TEMPLATE_CARD_PADDING_Y = 10;

/** Reject Konva reads before webfonts/layout — zero boxes make text disappear on canvas. */
export const isValidTextLayoutMetrics = (width, height) =>
  Number.isFinite(width) &&
  Number.isFinite(height) &&
  width > 0.5 &&
  height > 0.5;

/** Prefer live Konva metrics when the text node is mounted (matches drag-end sync). */
export const getTextAnnotationLayoutForCardSync = (designLayer, textAnnotation) => {
  if (!textAnnotation?.id || !designLayer?.findOne) {
    return textAnnotation;
  }
  const node = designLayer.findOne(`#${textAnnotation.id}`);
  if (!node || node.name() !== TOOLS_IDS.TEXT) {
    return textAnnotation;
  }
  node._setTextData?.();
  const width = node.width() * node.scaleX();
  const height = node.height() * node.scaleY();
  if (!isValidTextLayoutMetrics(width, height)) {
    return textAnnotation;
  }
  return {
    ...textAnnotation,
    x: node.x(),
    y: node.y(),
    width,
    height,
    rotation: node.rotation(),
  };
};

/** Layout for the dark card rect behind template / sticker text. */
export const buildCardBackgroundRectLayout = (textAnnotation) => {
  const tx = Number(textAnnotation.x) || 0;
  const ty = Number(textAnnotation.y) || 0;
  const tw = Number(textAnnotation.width) || 0;
  const th = Number(textAnnotation.height) || 0;

  return {
    x: tx - TEXT_TEMPLATE_CARD_PADDING_X,
    y: ty - TEXT_TEMPLATE_CARD_PADDING_Y,
    width: tw + TEXT_TEMPLATE_CARD_PADDING_X * 2,
    height: th + TEXT_TEMPLATE_CARD_PADDING_Y * 2,
    rotation: textAnnotation.rotation ?? 0,
  };
};

export const findCardBackgroundPartnerId = (annotations, textId) => {
  const text = annotations?.[textId];
  if (!text || text.name !== TOOLS_IDS.TEXT || !text.groupId) {
    return null;
  }

  const partner = getAnnotationsInGroup(annotations, text.groupId).find(
    (member) =>
      member.id !== textId &&
      (member[TEMPLATE_CARD_BACKGROUND_KEY] || member.name === TOOLS_IDS.RECT),
  );

  return partner?.id ?? null;
};

export const hasTemplateCardBackground = (annotations, textId) =>
  Boolean(findCardBackgroundPartnerId(annotations, textId));

export const buildCardBackgroundPatchForText = (annotations, textAnnotation) => {
  const cardId = findCardBackgroundPartnerId(annotations, textAnnotation.id);
  if (!cardId) {
    return null;
  }
  const card = annotations[cardId];
  if (!card || card.locked) {
    return null;
  }
  return {
    ...card,
    ...buildCardBackgroundRectLayout(textAnnotation),
  };
};
